import React, {useContext} from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { Chip, Grid2 as Grid, Link, useMediaQuery } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { FilersDataContext } from '../../Filers';


const FilerBasics = (): JSX.Element => {
  const theme = useTheme();
  const FilerDataContext = useContext(FilersDataContext);
  const currentFiler = FilerDataContext.currentFilerPayload?.filer;
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));


  const displayCandidateOfficeSought = () => {

    if(currentFiler?.officeSought.districtCode === currentFiler?.officeHeld.districtCode){
      if(currentFiler?.officeSought.officeDescription === "Senate"){
        return <Typography variant='subtitle1' fontWeight={550}>Senator, {currentFiler?.officeSought.districtDescription}</Typography>
      }
      if(currentFiler?.officeSought.officeDescription === "House"){
        return <Typography variant='subtitle1' fontWeight={550}>House Representative, {currentFiler?.officeSought.districtDescription}</Typography>
      }
      if(currentFiler?.officeSought.officeDescription === "Mayoral"){
        return <Typography variant='subtitle1' fontWeight={550}>Mayor, {currentFiler?.officeSought.districtDescription}</Typography>
      }
      return <Typography variant='subtitle1' fontWeight={550}>{currentFiler?.officeSoughtDescription}</Typography>
    }
    else{
      return(
        <>
          <Typography variant='subtitle1' fontWeight={550}>
            Candidate for {currentFiler?.officeSoughtDescription}
          </Typography>
        </>
      ) 
    }
  }

  return (
    <Card
    sx={{
      p: { xs: 2, md: 4 },
      paddingTop: 2,
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      width: 1,
      height: 1,
    }}>
      {
        currentFiler?.isCandidate && currentFiler?.filerPhotoUrl &&
        <Stack
          spacing={2}
          width={{ xs: 1, sm: 'auto' }}
          alignItems={'center'}
          marginRight={1}
        >
          <Avatar
            src={currentFiler?.filerPhotoUrl}
            variant={'circular'}
            sx={{
              width: theme.spacing(18),
              height: theme.spacing(18),
          }}
          />
        </Stack>
      }
    <Box marginLeft={{ xs: 0, md: 2 }}>
      {/* filer name*/}
      <Stack direction={'column'} spacing={0.1} alignItems={isSM ? 'center' : 'flex-start'} marginTop={isSM ? 1 : 0}>
        <Typography variant='subtitle1' fontWeight={550}>
          {currentFiler?.cpfId} {currentFiler?.fullNameReverse}
        </Typography>
      </Stack>
      {/* office sought */}
      {
        currentFiler?.isCandidate &&
        <Stack direction={'column'} spacing={0.1} alignItems={isSM ? 'center' : 'flex-start'}>
          {
            currentFiler?.accountType.isLocalFiler?
            <Typography variant='subtitle1' fontWeight={550}>{currentFiler?.accountType.display}</Typography>
            :
            displayCandidateOfficeSought()
          }
        </Stack>
      }
      {/*List of basic info tags*/}
      <Stack
        direction={'row'}
        spacing={{ xs: 1, md: 2 }}
        marginY={2}
        alignItems={'flex-start'}
        useFlexGap
        flexWrap="wrap">
        {
          currentFiler?.isCandidate && !currentFiler?.accountType.isLocalFiler &&
          currentFiler.officeSought.districtCode === currentFiler.officeHeld.districtCode &&
          <Chip label="Incumbent" color="success" variant="outlined" />
        }
        {
          currentFiler?.isCandidate && currentFiler.partyAffiliation.length> 0 && currentFiler.partyAffiliation !== "Unenrolled" &&
          <Chip label={`${currentFiler.partyAffiliation}`} color="primary" variant="outlined" />
        }
        {
          currentFiler?.isCandidate && !currentFiler?.accountType.isLocalFiler ? 
          <Chip label={`${currentFiler?.officeSought?.officeDescription} Candidate`} color="primary" variant="outlined" /> : <Chip label={`${currentFiler?.accountType.description}`} color="primary" variant="outlined" />
        }
        {
          currentFiler?.isActive ?
          <Chip label={`Organized on ${currentFiler.organizationDate}`} color="primary" variant="outlined" />:
          <>
            <Chip label="Closed Filer" color="error" variant="outlined" />
            <Chip label={`Organization Range: ${currentFiler?.organizationDate} - ${currentFiler?.closedDate}`} color="primary" variant="outlined" />
          </>
        }
        {
          currentFiler?.isCandidate && currentFiler?.isCandidateOnly &&
          <Chip label={"Candidate Only"} color="warning" variant="outlined" />
        }
      </Stack>
      {
        currentFiler?.organizationStatementBlobUrl &&
        <Stack direction={'row'} spacing={1}>
          <PictureAsPdfIcon />
          <Link href={`${currentFiler?.organizationStatementBlobUrl}`} target="_blank" color="inherit">Organization Statement</Link>
        </Stack>
      }
    </Box>
    </Card>
  );
};

export default FilerBasics;

